import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './News.scss';
import groupBy from 'lodash.groupby';
import toPairs from 'lodash.topairs';
import cn from 'classnames';
import Sticky from 'react-sticky-el';
import { connect } from 'react-redux';
import { setPopUp } from 'actions/environment';
import { allNews, nedvexNews, favoritesNews } from 'actions/news';
import { formatDate, formatTime } from 'utils';
import { ROOT_URL } from 'constants/Config';
import { withTranslation } from 'react-i18next';
import { linkifyText } from '../../Building/Main/helper';
import logoNedvex from 'assets/images/logo-nedvex-char.svg';
import tracker from '../../../services/tracker';
import { gaEvent, trackGA } from 'services/ga';

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'allNewsData',
      offset: 0,
      shownNews: new Set(),
    };
  }

  componentDidMount = () => {
    this.props.allNews({ limit: 20, offset: 0 });
    this.props.nedvexNews({ limit: 20, offset: 0 });
    this.props.favoritesNews({ limit: 20, offset: 0 });
    this.ref.addEventListener('scroll', this.handleScroll);
  };

  componentWillUnmount = () => {
    this.ref.removeEventListener('scroll', this.handleScroll);
  };

  newsDidMount = (ref) => {
    this.ref = ref;
  };

  handleEvent = (eventName, item) => {
    const { profile, objectType } = this.props;
    const { mode } = this.state;

    let newsMode;
    switch (mode) {
      case 'allNewsData':
        newsMode = 'vse';
        break;
      case 'favoritesNewsData':
        newsMode = 'izbrannoe';
        break;
      case 'nedvexNewsData':
        newsMode = 'ot_servisa';
        break;
      default:
        break;
    }

    trackGA(
      gaEvent[eventName]({
        screenName: '/',
        eventContext: newsMode,
        eventContent: item.building ? item.building.name : '',
        productType: objectType,
        productName: item.building ? item.building.name : '',
        productID: item.building ? item.building.id : '',
        user_id: profile.id,
      })
    );
  };

  handleLinkClick = (e, item) => {
    e.stopPropagation();
    this.handleEvent('newsCardObjectLinkClick', item);
  };

  handlePopupLinkClick = () => {
    this.props.setPopUp(undefined);
  };

  handleScroll = (e) => {
    const { loading, finished } = this.props[this.state.mode];
    if (
      (e.currentTarget.scrollHeight > e.currentTarget.scrollWidth
        ? e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight <
          200
        : e.currentTarget.scrollWidth - e.currentTarget.scrollLeft - e.currentTarget.clientWidth <
          200) &&
      !loading &&
      !finished
    ) {
      this.loadNews(this.state.mode);
    }
  };

  loadNews = (mode, reset = false) => {
    const { offset } = this.state;
    const newOffset = reset ? 0 : offset;

    switch (mode) {
      case 'allNewsData':
        this.props.allNews({ limit: 20, offset: newOffset });
        break;
      case 'nedvexNewsData':
        this.props.nedvexNews({ limit: 20, offset: newOffset });
        break;
      case 'favoritesNewsData':
        this.props.favoritesNews({ limit: 20, offset: newOffset });
        break;
      default:
        break;
    }

    if (reset) {
      this.setState({ offset: 20 });
    } else {
      this.setState({ offset: offset + 20 });
    }
  };

  handleModeChange = (mode) => {
    this.setState({ mode, offset: 0 }, () => {
      this.loadNews(mode, true);
    });
  };

  handleMoreClick = (item) => {
    this.handleEvent('newsCardClick', item);

    this.props.setPopUp(
      <div className={styles.NewsPopupWrap}>
        {this.renderPopupTitle(item)}
        <div className={cn(styles.PopupNewsList, 'custom-scrollbar')}>
          <div className={styles.PopupNewsItem}>
            <time className={styles.PopupNewsItemDate}>
              {formatDate(item.dateUpdate)}, {formatTime(item.dateUpdate)}
            </time>
            <p className={styles.PopupNewsItemText}>{linkifyText(item.name)}</p>
          </div>
        </div>
      </div>,
      {
        className: styles.NewsPopup,
        contentClassName: styles.NewsPopupContent,
        closeStyleName: 'Default',
        closeClassName: styles.NewsPopupClose,
        contentStyleName: 'Default',
        closeIcon: 'default',
      }
    );
  };

  renderPopupTitle = (item) => (
    <div className={styles.PopupTitle} onClick={(e) => this.handleLinkClick(e, item)}>
      {item.building ? (
        item.building.image ? (
          <Link to={`/building/${item.building.id}`} onClick={this.handlePopupLinkClick.bind(this)}>
            <img
              src={`${ROOT_URL}/image?id=${item.building.image.id}&size=small`}
              className={styles.PopupTitleImg}
              alt=""
            />
          </Link>
        ) : null
      ) : (
        <img src={logoNedvex} className={styles.PopupTitleNedvexImg} alt="" />
      )}
      <span>
        {item.building ? (
          <Link to={`/building/${item.building.id}`} onClick={this.handlePopupLinkClick.bind(this)}>
            {item.building.name}
          </Link>
        ) : (
          <div>ОТ NEDVEX</div>
        )}
      </span>
    </div>
  );

  handleNewsCardShow = ({ newsId, newsTitle, productName, productID }) => {
    if (!this.state.shownNews.has(newsId)) {
      this.handleEvent('newsCardShow', {
        name: newsTitle,
        building: { name: productName, id: productID },
      });

      this.setState((prevState) => {
        const updatedShownNews = new Set(prevState.shownNews);
        updatedShownNews.add(newsId);
        return { shownNews: updatedShownNews };
      });
    }
  };

  renderNewsTitle(item) {
    const { building } = item;

    this.handleNewsCardShow({
      newsId: item.id,
      newsTitle: item ? item.name : '',
      productName: building ? building.name : '',
      productID: building ? building.id : '',
    });

    return (
      <div className={styles.NewsHeader}>
        {item.building ? (
          item.building.image && (
            <img
              src={`${ROOT_URL}/image?id=${item.building.image.id}&size=small`}
              className={styles.NewsHeaderImg}
              alt=""
            />
          )
        ) : (
          <img src={logoNedvex} className={styles.NewsHeaderImg} alt="" />
        )}
        <div className={styles.NewsHeaderRight}>
          <p className={styles.ObjectName}>{item.building ? item.building.name : 'ОТ NEDVEX'}</p>
          <time className={styles.NewsTime}>
            {formatDate(item.dateUpdate)}, {formatTime(item.dateUpdate)}
          </time>
        </div>
      </div>
    );
  }

  handleButtonClick = ({ buttonName }) => {
    const { profile, mode, objectType } = this.props;

    trackGA(
      gaEvent.newsButtonsClick({
        eventLabel: buttonName,
        eventContext: mode,
        productType: objectType,
        user_id: profile.id,
      })
    );
  };

  render() {
    const { mode } = this.state;
    const { t } = this.props;
    const { data } = this.props[mode];
    const groupedData =
      data && data.length
        ? toPairs(groupBy(data, ({ dateUpdate }) => dateUpdate.split(' ')[0])).sort((a, b) =>
            a[0] < b[0] ? 1 : -1
          )
        : [];

    const items = groupedData.map(([date, array]) => [
      <Sticky
        key={date}
        scrollElement=".scrollarea"
        stickyClassName={styles.stickyEl}
        className={styles.NewsFeedItemDate}
      >
        {formatDate(date)}
      </Sticky>,
      // <div className={styles.NewsFeedItemDate}>
      //   {formatDate(date)}
      // </div>,
      array.map((item) => (
        <div
          key={item.id}
          className={cn(styles.NewsFeedItem, {
            [styles.Marked]: false,
            [styles.Nedvex]: !item.building,
          })}
          onClick={() => this.handleMoreClick(item)}
        >
          {item.building ? (
            <Link
              to={`/building/${item.building.id}`}
              className={styles.NewsLink}
              // onClick={(e) => this.handleLinkClick(e, item)}
            >
              {this.renderNewsTitle(item)}
            </Link>
          ) : (
            this.renderNewsTitle(item)
          )}
          <div className={styles.NewsText}>{linkifyText(item.name, 100)}</div>
          {item.name.length > 100 ? (
            <span className={styles.ReadMore}>{t('components.buildings.news.readMore')}</span>
          ) : null}
        </div>
      )),
    ]);

    return (
      <div className={styles.NewsFeedWrap}>
        <div className={styles.NewsFeed}>
          <p className={styles.NewsFeedTitle}>{t('components.buildings.news.title')}</p>

          <div className={styles.ButtonGroup}>
            <div
              className={cn({ [styles.ActiveMode]: mode === 'allNewsData' })}
              onClick={() => {
                tracker.sendEvent('Web_List_News_All');
                this.handleModeChange('allNewsData');
                this.handleButtonClick({ buttonName: 'vse' });
              }}
            >
              {t('components.buildings.news.all')}
            </div>
            <div
              className={cn({ [styles.ActiveMode]: mode === 'favoritesNewsData' })}
              onClick={() => {
                tracker.sendEvent('Web_List_News_Favorites');
                this.handleModeChange('favoritesNewsData');
                this.handleButtonClick({ buttonName: 'izbrannoe' });
              }}
            >
              {t('components.buildings.news.favorite')}
            </div>
            <div
              className={cn({ [styles.ActiveMode]: mode === 'nedvexNewsData' })}
              onClick={() => {
                tracker.sendEvent('Web_List_News_From_Service');
                this.handleModeChange('nedvexNewsData');
                this.handleButtonClick({ buttonName: 'ot_servisa' });
              }}
            >
              {t('components.buildings.news.fromService')}
            </div>
          </div>

          <div
            className={cn(styles.scrollArea, 'scrollarea', 'custom-scrollbar')}
            ref={this.newsDidMount}
          >
            {items}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      allNewsData: state.allNews,
      nedvexNewsData: state.nedvexNews,
      favoritesNewsData: state.favoritesNews,
      profile: state.profile,
    }),
    { setPopUp, allNews, nedvexNews, favoritesNews }
  )(News)
);



// WEBPACK FOOTER //
// ./src/components/Buildings/News/News.js